<template>
  <div>
    <div class="create-accordian-section">
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton1"><li>Value Added Services</li></a>
          <a href="javascript:void(0)" @click="backButton2"><li>&nbsp;>&nbsp;My WILL</li></a>
          <li v-if="this.$route.params.type == 'amend'">&nbsp;>&nbsp;Will Amendation</li>
          <li v-else>&nbsp;>&nbsp;Will Creation</li>
        </ul>
        <h2 v-if="this.$route.params.type == 'amend'">WILL Amendation</h2>
        <h2 v-else>WILL Creation</h2>
        <div class="row">
          <div class="col-sm-6">
            <label  style="font-size:20px; font-weigth:500px; color:#1a407d; position:relative">Choose Member For Will {{this.$route.params.type == 'amend' ? 'Amendation' : 'Creation'}}</label>
            <div style="margin-top:13px !important">
              <v-select class ="col-sm-6"
                name="will_creation_memeber"  
                v-model="will_creation_memeber"
				:items="will_creation_memeber_list"
                id="will_creation_memeber"
                item-value="ids"
                item-text="name"
                placeholder="Choose Member"
                style="border:1px black !important" 
                @change="setMainMember($event)"
                solo
              ></v-select>
              <span style="color:red; display:none;" id="will_creation_memeber_err">Choose from Dropdown!</span>
            </div>  
          </div>
        </div>  
        <div class="accodian-box">
          <v-app id="inspire">
            <v-expansion-panels>
	            <MemberPersonalInfo :all_member_list="all_member_list" :relation_list="relation_list" ref="PartA" :will_id="`${this.will_id}`"/>
				<DistributeWealth :relation_list="relation_list" ref="child_form"/>
				<WitnessDetails :member_id="`${this.member_id}`" :will_id="`${this.will_id}`" :relation_list="relation_list" ref="witness_form"/>
				<ExecutorsDetails :will_id="`${this.will_id}`" ref="executor_form"/>
            </v-expansion-panels>
          </v-app>
          <div class="text-center">
            <button class="will-button1 saveProceed" @click="saveProceed">
              PROCEED
            </button>
          </div>
        </div>
      </div>
    </div>
    <v-dialog content-class="modal-style" v-model="procced_dialog" persistent height="800px"
      max-width="892px">
	    <v-card>
	        <div class="header-section d-flex justify-content-between">
	            <h2 class="header">
	              MY<sub style="color: #f19700; font-size: 18px"> WILL</sub>
	            </h2>
	            <span class="cross-icon">
	              <v-img @click="procced_dialog = false" :src="require('@/assets/images/cross.png')"></v-img>
	            </span>
	        </div>
	        <h3 class="sub-head">Generate Your WILL</h3>
	        <div class="dialog-para">
		        <p>
		            Now that you have provided all your information you can either
		            “Save” the data or click to “Preview” and “Confirm” your WILL.
		        </p>
		        <p>
		            If you choose “Save” option your information will be saved and you
		            will have 15 days to make any changes and proceed towards WILL
		            creation. Post 15 days you will have the option to “Preview” and
		            “Confirm” your WILL. “Preview” option will help you to make
		            necessary changes in the document before you “Confirm”. Once you
		            “Confirm”, your WILL be generated in a PDF format. You can download
		            the same. Please sign every page of the document and get it attested
		            by the two witnesses specified.
		        </p>
		        <p>
		            You can notarize or register your WILL document. Nimeya in
		            association with “ABC Ltd” will assist you in notarization or
		            registration of your WILL. Do select the appropriate option at the
		            time of generating PDF report.
		        </p>
		        <p>
		            Please note noratization or registration of WILL is not a mandatory
		            requirement as per law however, we would recommend the same to avoid
		            any litigation at a future date.
		        </p>
	        </div>
	        <div class="button-group">
	          <button class="btn save-btn" @click="details()">SAVE</button>
	          <button class="btn cancle-btn" @click="procced_dialog = false">PREVIEW</button>
	          <button class="btn cancle-btn" @click="confirm()">CONFIRM</button>
	        </div>
	    </v-card>
    </v-dialog>
  </div>
</template>
<script>
    import MemberPersonalInfo from './MemberPersonalInfo';
		import DistributeWealth from './DistributeWealth.vue';
		import WitnessDetails from './WitnessDetails.vue';
		import ExecutorsDetails from './ExecutorsDetails.vue';
    import axios from 'axios';
    import { Auth } from "aws-amplify";
    export default {
	    components: {
	       MemberPersonalInfo,
		   DistributeWealth,
		   WitnessDetails,
		   ExecutorsDetails
	    },
	    data: () => ({
	      will_creation_memeber:{},
	      will_creation_memeber_list:[],
	      procced_dialog:false,
	      user_name:'',
		   	member_id:'',
		   	will_id:'',
		   	relation_list:[],
		   	all_member_list:[]
	    }),
	    mounted() {
	    	if (this.$route.params.willId) {
	    		let willId = this.$route.params.willId;
	    		axios
	    			.post(
	    				process.env.VUE_APP_ROOT_API + "get-will-info",
	    				{
	    					awsCognitoId:atob(localStorage.getItem('cognito_idp')),
	    					id:willId
	    				}
	    			)
	    			.then((response) => {
	    				let res = response.data.data;
	    				this.will_creation_memeber = {id:res.id, name:res.name, member_id:res.member_id, ids: {will_id:res.id, member_id:res.member_id}};
	    				setTimeout(() => {
	    					this.setMainMember({will_id:res.id, member_id:res.member_id});
	    				}, 1000);
		  			});
	    	}
	      this.initializeMainMember();
	    },
	    methods: {
	    	initializeMainMember() {
	        Auth.currentAuthenticatedUser({
	  				bypassCache: false
	  	    })
	  	    .then(user => {	
			this.user_name = user.attributes["custom:name"];
			let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
			let formdata  = new FormData();
			formdata.append("aws_cognito_id", cognito_idp);
			formdata.append("user_name", user.attributes["custom:name"]);
			formdata.append("type", this.$route.params.type);
            axios.post(process.env.VUE_APP_ROOT_API + "selected-member-list", formdata).then((response) => {
              this.will_creation_memeber_list = response.data.will_member_list
              this.all_member_list = response.data.all_member_list;
              this.relation_list = response.data.relation_list
		  			})
	        })
        },
	    	details(){
					this.$router.push({ path: '/MemberDetails/'+this.$route.params.type }).catch(() => {});
	    	},
	    	confirm(){
					this.$router.push({ path: '/AccountDetails/'+this.will_id+'/'+this.member_id}).catch(() => {});
	    	},
	    	backButton1() {
		        this.$router.push({ name: 'ValueAddedServices' }).catch(() => {});
		    },
		    backButton2() {
		        this.$router.push({ name: 'MyWill' }).catch(() => {});
		    }, 
		     
		    setMainMember(e){
					this.member_id = e.member_id;
					this.will_id = e.will_id;
					this.$refs.PartA.fillMembersData(e.member_id,e.will_id);
					this.$refs.child_form.depositDetails(this.member_id,this.will_id);
					this.$refs.witness_form.getWitnessDetails(this.will_id);
					this.$refs.executor_form.getExecutorDetails(this.will_id);
		    },

		    saveProceed(){
		    	if(this.will_id === ''){
		    		swal.fire({
						  title:'Error!',
						  text:'First Please Choose A Member For Will Creation',
						  icon:'error'
						})
		    	}
		    	else {
		    		axios
		    			.post(
		    				process.env.VUE_APP_ROOT_API + "validate-will-data",
		    				{
		    					'aws_cognito_id':atob(localStorage.getItem('cognito_idp')),
		    					'member_id':this.member_id,
		    					'will_id':this.will_id
		    				}
		    			)
		    			.then((response) => {
		    				if(response.data.status == 'error'){
		    					swal.fire({
									  title:'Error!',
									  text:response.data.message,
									  icon:'error'
									})
		    				}
		    				else {
		    					this.procced_dialog = true
		    				}
		  				})
		    	}
		    }
	    },
    };
</script>
<style>
	.dialog-para {
	  font-size: 14px;
	  color: #333333;
	  font-style: 'Lato';
	}
	.disabled {
	  pointer-events:none;
	}
</style>